import axios from '@/libs/api.request'

export const getNewsinfolist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/newsinfo/newsinfo/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationNewsinfo = (data, meth) => {
  return axios.request({
    url: '/v1/newsinfo/newsinfo/',
    method: meth,
    data
  })
}